import React, { useEffect, useState, useRef } from 'react';
import { GlassCard } from '../../ui/Card';
import iviMockup from '../../assets/ivimockup.png';
import premierMockup from '../../assets/premiermockup.png';
import appsmartMockup1 from '../../assets/appsmartmockup1.png';
import appsmartMockup2 from '../../assets/appsmartmockup2.png';
import PortfolioContactSection from './PortfolioContactSection';
import PortfolioSkeleton from '../../components/skeletons/PortfolioSkeleton';

interface PortfolioPageProps {
    onBack: () => void;
}

const PortfolioPage: React.FC<PortfolioPageProps> = ({ onBack }) => {
    const [isLoading, setIsLoading] = useState(true);
    const firstItemRef = useRef<HTMLDivElement>(null);
    const portfolioItems = [
        {
            title: 'Иви',
            period: 'Android Developer (2024-2025)',
            image: iviMockup,
            description: 'Разработка и развитие одного из крупнейших видеосервисов в СНГ с миллионами пользователей.',
            details: 'Фокусировалась на стабильности контентного плеера, качестве воспроизведения и развитии пользовательских сценариев. Участвовала в рефакторинге, переходе на Jetpack Compose и улучшении качества продакшн-кода.',
            results: [
                'Реализовала новый раздел «Мини-драмы», расширив контентное предложение сервиса',
                'Улучшила стабильность контентного плеера и качество воспроизведения видео',
                'Повысила надёжность трансляций через Google Cast',
                'Снизила количество критических багов и утечек памяти за счёт мониторинга и оптимизаций',
                'Участвовала в планировании задач, код-ревью и ведении спринт-встреч'
            ],
            technologies: ['Android SDK', 'Kotlin', 'Coroutines', 'Java', 'RxJava 2', 'Jetpack Compose', 'ExoPlayer', 'Google Cast', 'Firebase', 'Crashlytics']
        },
        {
            title: 'Билайн Попкорн',
            period: 'Android Developer (2024)',
            description: 'Разработка онлайн-кинотеатра Билайн Попкорн для Android и Android TV, доступного в нескольких странах.',
            details: 'Работала над визуальной и архитектурной эволюцией приложения: внедряла дизайн-систему, участвовала в переходе на Jetpack Compose и развитии внутренних процессов разработки. Реализовывала новый функционал и поддерживала существующий код.',
            results: [
                'Внедрила дизайн-систему, повысив консистентность UI и скорость разработки новых экранов',
                'Участвовала в миграции приложения на Jetpack Compose',
                'Повысила качество кода через регулярные код-ревью и участие в формировании процессов разработки',
                'Внесла вклад в развитие продукта для нескольких рынков'
            ],
            technologies: ['Android SDK', 'Kotlin', 'Coroutines', 'Java', 'RxJava 2', 'Jetpack Compose', 'ExoPlayer']
        },
        {
            title: 'Premier (Газпром-медиа)',
            period: 'Senior Android Developer / Team Lead (2021-2024)',
            image: premierMockup,
            description: 'Разработка стримингового сервиса Premier для Android и Android TV — крупного медиа-продукта с высокой пользовательской нагрузкой.',
            details: 'Отвечала за развитие функциональности, техническое качество и delivery фич. Управляла фича-командой, участвовала в формировании архитектурных решений, системном анализе требований и подготовке ТЗ. Вела собеседования, код-ревью и менторство.',
            results: [
                'Построила полноценный CI/CD-пайплайн: сборка, анализ кода, тестирование, уведомления и деплой в маркеты',
                'Внедрила Jetpack Compose в продакшн и запустила постепенную миграцию',
                'Инициировала эксперименты с Kotlin Multiplatform',
                'Довела фичу «Радио» от аналитики и документации клиент-серверного взаимодействия до релиза',
                'Участвовала в разработке внутреннего бота для интеграции Jira и мессенджеров'
            ],
            technologies: ['Android SDK', 'Kotlin', 'Coroutines', 'Flow', 'MVVM', 'Jetpack Compose', 'Kotlin Multiplatform', 'Retrofit', 'Glide', 'Custom Views', 'Kaspresso', 'Toothpick', 'GitLab CI']
        },
        {
            title: 'App Smart GmbH',
            period: 'Android / Backend Engineer (2019-2021)',
            images: [appsmartMockup1, appsmartMockup2],
            description: 'Немецкая продуктовая компания, разрабатывающая мобильные приложения для ресторанов в нескольких странах Европы.',
            details: 'Разрабатывала и поддерживала Android-приложения для агрегатора и системы управления заказами, участвовала в проектировании архитектуры и интеграции сторонних сервисов (карты, геолокация, web-контент). Параллельно разрабатывала backend-микросервисы и выстраивала процессы автоматизированного деплоя мобильных приложений.',
            results: [
                'Реализовала Android-приложения, используемые ресторанами в нескольких странах Европы',
                'Улучшила стабильность и расширяемость приложений за счёт MVVM / MVI',
                'Внедрила автоматический деплой Android-приложений, сократив время релизов и ручные операции',
                'Участвовала в построении микросервисной backend-архитектуры'
            ],
            technologies: ['Android SDK', 'Kotlin', 'Coroutines', 'RxKotlin', 'Jetpack (Navigation, ViewModel)', 'Google Maps / Places / Geocoding', 'Retrofit', 'WebView', 'Java 11', 'Spring Boot', 'PostgreSQL', 'MongoDB', 'RabbitMQ', 'Jenkins', 'Fastlane']
        },
        {
            title: 'Russian Robotics',
            period: 'Backend Developer / Java Developer (2018-2019)',
            description: 'Участвовала в разработке и развитии backend-систем для предоставления государственных услуг и интеграции с внешними ведомствами через СМЭВ.',
            details: 'Разрабатывала микросервис для взаимодействия с СМЭВ, включая обработку SOAP/REST-запросов, асинхронные очереди и хранение данных. Поддерживала и дорабатывала существующую систему предоставления услуг на Java EE, обеспечивая стабильность и расширяемость legacy-решений.',
            results: [
                'Реализовала микросервис для интеграции со СМЭВ, обеспечив надёжный обмен данными между системами',
                'Улучшила стабильность и поддерживаемость backend-решений за счёт перехода к Spring-стеку',
                'Участвовала в модернизации legacy-систем на Java EE',
                'Контейнеризировала сервисы, упростив деплой и сопровождение'
            ],
            technologies: ['Java Spring Framework (Boot, Data JPA)', 'Java EE', 'Kotlin', 'Java 8', 'PostgreSQL', 'RabbitMQ', 'Hibernate', 'SOAP', 'REST', 'Docker', 'Linux', 'Git', 'Maven', 'Gradle', 'Thymeleaf', 'Tomcat', 'WildFly']
        },
        {
            title: 'Магнит',
            period: 'Backend Developer / Java Developer (2017-2018)',
            description: 'Разработка backend-систем для транспортной логистики и внутренних корпоративных сервисов крупного ритейлера.',
            details: 'Разрабатывала микросервисы для логистических процессов, участвовала в доработке системы централизованной отчётности и поддержке Android-приложений для планшетов. Работала с реляционными БД, очередями сообщений и web-интерфейсами.',
            results: [
                'Реализовала и развивала микросервисы для транспортной логистики',
                'Улучшила систему централизованной отчётности и генерации документов',
                'Работала с несколькими СУБД (PostgreSQL, Oracle) в рамках одного продукта',
                'Участвовала в доработке Android-приложений для внутренних пользователей',
                'Повысила стабильность backend-сервисов за счёт оптимизации работы с БД и очередями'
            ],
            technologies: ['Java Spring Framework (Boot, Data JPA)', 'Java 8', 'PostgreSQL', 'Oracle', 'Hibernate', 'JDBC', 'RabbitMQ', 'RESTful Web Services', 'Git', 'Gradle', 'JavaScript', 'JSP', 'jQuery', 'Bootstrap', 'Apache POI', 'Android Studio']
        }
    ];

    useEffect(() => {
        // Simulate loading
        const timer = setTimeout(() => {
            setIsLoading(false);
            // Scroll to first item after loading
            setTimeout(() => {
                if (firstItemRef.current) {
                    const offsetTop = firstItemRef.current.offsetTop - 80;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <PortfolioSkeleton />;
    }

    return (
        <div className="portfolio-page">
            <div className="container">
                <div className="portfolio-grid">
                    {portfolioItems.map((item, index) => (
                        <div 
                            key={index}
                            ref={index === 0 ? firstItemRef : null}
                        >
                            <GlassCard className="portfolio-item reveal">
                                <div className="portfolio-item-header">
                                    <h3 className="section-title">
                                        <strong>{item.title}</strong>
                                    </h3>
                                    <p className="portfolio-period">{item.period}</p>
                                </div>
                                {item.images && item.images.length > 0 && (
                                    <div className="portfolio-images-top">
                                        {item.images.map((img, imgIndex) => (
                                            <div key={imgIndex} className="portfolio-image-wrapper-top">
                                                <img src={img} alt={`${item.title} ${imgIndex + 1}`} className="portfolio-image" />
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {item.images && item.images.length > 0 ? (
                                    <div className="portfolio-text-content-full">
                                        <p className="portfolio-description">
                                            {item.description}
                                        </p>
                                        {item.details && (
                                            <p className="portfolio-details">
                                                {item.details}
                                            </p>
                                        )}
                                    </div>
                                ) : (
                                    <div className="portfolio-content-wrapper">
                                        {item.image && (
                                            <div className="portfolio-image-wrapper">
                                                <img src={item.image} alt={item.title} className="portfolio-image" />
                                            </div>
                                        )}
                                        <div className="portfolio-text-content">
                                            <p className="portfolio-description">
                                                {item.description}
                                            </p>
                                            {item.details && (
                                                <p className="portfolio-details">
                                                    {item.details}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <div className="portfolio-bottom-section">
                                    {item.results && item.results.length > 0 && (
                                        <div className="portfolio-results">
                                            <h4 className="portfolio-results-title">Результаты:</h4>
                                            <ul className="portfolio-results-list">
                                                {item.results.map((result, resultIndex) => (
                                                    <li key={resultIndex}>{result}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    <div className="portfolio-technologies">
                                        <h4 className="portfolio-tech-title">Стек:</h4>
                                        <div className="tech-badges-wrapper">
                                            {item.technologies.map((tech, techIndex) => (
                                                <span key={techIndex} className="tech-badge">
                                                    {tech}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </GlassCard>
                        </div>
                    ))}
                </div>

                <PortfolioContactSection/>
            </div>
        </div>
    );
};

export default PortfolioPage;
